import React from 'react';
import EmptySection from '../Utils/emptySpace';
import { Object1, Object2 } from '../Components/Home/According/data';
import { PageStyle } from '../Utils/generalStyles';

// Components
import GreetSection from '../Components/Home/Greet';
import ImageSection from '../Components/Home/Images';
import AccordingSection from '../Components/Home/According';
import FooterSection from '../Components/Footer';

const HomePage = () => (
  <PageStyle>
    <GreetSection />
    <EmptySection color="#F0FFE6" />
    <ImageSection />
    <EmptySection color="#F0FFE6" />
    <AccordingSection {...Object1} />
    <EmptySection color="#F0FFE6" />
    <AccordingSection {...Object2} />
    <EmptySection color="#F0FFE6" />
    <FooterSection />
  </PageStyle>
);

export default HomePage;
